import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import Cta from 'component/Layout/Cta';
import { CtaType } from 'component/Layout/Cta/types';

import styles from '../Location.module.scss';
import { LocationFilterType } from '../types';

import Item from './Item';

interface OverlayProps {
    children: ReactNode;
    type: LocationFilterType;
    isSelectionEmpty: boolean;
    onClearSelection: () => void;
    onSubmit: () => void;
}

const Overlay = ({
    children,
    type,
    isSelectionEmpty,
    onClearSelection,
    onSubmit,
}: OverlayProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.ListContainer}>
            <div className={styles.ScrollContainer}>
                <Item
                    type={type}
                    item={{
                        id: 0,
                        name:
                            type === LocationFilterType.Region
                                ? t('TRANS-all-regions')
                                : t('TRANS-all-locations'),
                    }}
                    onSelection={onClearSelection}
                    isSelected={isSelectionEmpty}
                />
                <hr />
                {children}
            </div>
            <div className={styles.Button}>
                <Cta type={CtaType.BUTTON} onClick={onSubmit}>
                    {t('TRANS-apply')}
                </Cta>
            </div>
        </div>
    );
};

export default Overlay;
